export const SAVE_SEARCH_FIRST_TIME_TOOLTIP_SHOWN_KEY = 'saveSearchFirstTimeTooltipShown';
